import AuthLogin from "features/auth/screens/Login";
import ForgotPassword from "features/auth/screens/ForgotPassword";
import AuthOTP from "features/auth/screens/AuthOTP";
import ResetPassword from "features/auth/screens/ResetPassword";
import ROUTES from "./constant";

export const authRoutes = [
  { path: ROUTES.AUTH.LOGIN, element: <AuthLogin /> },
  { path: ROUTES.AUTH.LOGIN_OTP, element: <AuthOTP /> },
  { path: ROUTES.AUTH.FORGOT_PASSWORD, element: <ForgotPassword /> },
  { path: ROUTES.AUTH.FORGOT_PASSWORD_OTP, element: <AuthOTP /> },
  { path: ROUTES.AUTH.RESET_PASSWORD, element: <ResetPassword /> },
];
